import {
  JourneyProvider
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  AppState,
  getAuthToken,
  mapCatalogueCategories,
  mapCatalogueOffer,
  mapCatalogueVendor,
  onVouchersNoAuth
} from 'helpers';

import {
  CacheKeys,
  CacheStrategy,
  JavascriptTypes
} from '../../../../constants';

export class CatalogueProvider {

  static BASE_URL = Environment.current.catalogueHost + Environment.current.catalogueBase;
  static STATE = AppState.with('CatalogueProvider');

  static getDefaultHeaders() {
    return (
      {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + getAuthToken()
      }
    );
  }

  static async listCategory() {

    return CatalogueProvider.STATE.makeServiceCall(
      `${CatalogueProvider.BASE_URL}category`,
      {
        method: 'GET',
        headers: {
          ...CatalogueProvider.getDefaultHeaders()
        },
        cacheStrategy: CacheStrategy.CacheFirst,
        cacheKey: CacheKeys.VoucherAdvanceCategories,
        mapper: mapCatalogueCategories
      }
    )
    .then((res) => {

      if (!res?.ok) {

        return {
          ok: false,
          error: new Error('request failed'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      onVouchersNoAuth(error);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: error?.response?.status,
        stamp: new Date()
      };
    });
  }

  static async listProductOffering(categoryId) {

    return CatalogueProvider.STATE.makeServiceCall(
      `${CatalogueProvider.BASE_URL}productOffering`,
      {
        method: 'GET',
        headers: {
          ...CatalogueProvider.getDefaultHeaders()
        },
        queryParams: {
          'categoryId': categoryId
        },
        cacheStrategy: CacheStrategy.CacheFirst,
        cacheKey: `${CacheKeys.VoucherAdvanceProductList}-${categoryId}`,
        mapper: mapCatalogueVendor
      }
    )
    .then((res) => {

      if (!res?.ok) {

        return {
          ok: false,
          error: new Error('request failed'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      onVouchersNoAuth(error);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: error?.response?.status,
        stamp: new Date()
      };
    });
  }

  static async productOffering(productId) {

    return CatalogueProvider.STATE.makeServiceCall(
      `${CatalogueProvider.BASE_URL}productOffering/${productId}`,
      {
        method: 'GET',
        headers: {
          ...CatalogueProvider.getDefaultHeaders()
        },
        cacheKey: `${CacheKeys.VoucherAdvanceProductInfo}-${productId}`,
        cacheStrategy: CacheStrategy.CacheFirst,
        mapper: mapCatalogueOffer
      }
    )
    .then((res) => {

      if (!res?.ok) {

        return {
          ok: false,
          error: new Error('request failed'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      onVouchersNoAuth(error);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: error?.response?.status,
        stamp: new Date()
      };
    });
  }

  static async getCachedItem(key, fallback, serviceFallback) {

    const cachedItem = CatalogueProvider.STATE.getItem(key, fallback);

    if (!cachedItem && serviceFallback && typeof serviceFallback === JavascriptTypes.Function) {
      const response = await serviceFallback();

      if (response.ok && response.result) {
        CatalogueProvider.trackVolatileCache(key);
        return response;
      }

    }

    return cachedItem;
  }

  static trackVolatileCache(key) {
    const volatileCache = JourneyProvider.get(CacheKeys.Volatile, 'CatalogueProvider') || [];
    JourneyProvider.set(CacheKeys.Volatile, { CatalogueProvider: [ ...volatileCache, key ] });
  }

  static purgeVolatileCache() {
    const volatileCache = JourneyProvider.get(CacheKeys.Volatile, 'CatalogueProvider');
    for (let i = 0; i < volatileCache.length; i ++) {
      const key = volatileCache[i];
      CatalogueProvider.deleteCachedItem(key);
    }
    JourneyProvider.set(CacheKeys.Volatile, { CatalogueProvider: [] });
  }

  static deleteCachedItem(key) {
    CatalogueProvider.STATE.removeItem(key);
  }
}